// Google Analytics 4 Integration with Cookie Consent

const GA_MEASUREMENT_ID = 'G-XHDE4LTR07';

// Check if user has consented to analytics cookies
export const hasAnalyticsConsent = () => {
  try {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) return false;
    
    const preferences = JSON.parse(consent);
    return preferences.analytics === true;
  } catch (e) {
    return false;
  }
};

// Initialize Google Analytics
export const initGA = () => {
  if (!hasAnalyticsConsent()) {
    console.log('Analytics: User has not consented to analytics cookies');
    return;
  }

  // Check if GA is already loaded
  if (window.gtag) {
    console.log('Analytics: Already initialized');
    return;
  }

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true, // GDPR compliance
    cookie_flags: 'SameSite=None;Secure'
  });

  console.log('Analytics: Initialized with ID', GA_MEASUREMENT_ID);
};

// Track page view
export const trackPageView = (path) => {
  if (!hasAnalyticsConsent() || !window.gtag) return;
  
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title
  });
};

// Track custom event
export const trackEvent = (eventName, eventParams = {}) => {
  if (!hasAnalyticsConsent() || !window.gtag) return;
  
  window.gtag('event', eventName, eventParams);
};

// Track form submission
export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', {
    form_name: formName
  });
};

// Track button click
export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation
  });
};

// Track outbound link
export const trackOutboundLink = (url) => {
  trackEvent('outbound_click', {
    link_url: url
  });
};

// Remove GA if user revokes consent
export const removeGA = () => {
  // Remove GA cookies
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const name = cookie.split('=')[0].trim();
    if (name.startsWith('_ga') || name.startsWith('_gid')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });

  // Clear dataLayer
  if (window.dataLayer) {
    window.dataLayer = [];
  }

  // Remove gtag
  delete window.gtag;

  console.log('Analytics: Removed due to consent revocation');
};
